export default "__VITE_ASSET__BQJDQYsL__"